import app from 'flarum/forum/app';
import BreadcrumbBar from './BreadcrumbBar';
export const FEATURE_ID = 'breadcrumbs';
function mountBreadcrumbBar() {
  const drawer = document.getElementById('drawer');
  if (!drawer || document.getElementById('app-breadcrumbs')) {
    return;
  }
  const mountNode = document.createElement('div');
  mountNode.id = 'app-breadcrumbs';
  mountNode.className = 'App-breadcrumbs';
  drawer.insertAdjacentElement('afterend', mountNode);
  m.mount(mountNode, BreadcrumbBar);
}
export default function registerBreadcrumbs() {
  app.beforeMount(mountBreadcrumbBar);
}
flarum.reg.add('dia-theme', 'forum/features/breadcrumbs', registerBreadcrumbs);